/**
 * Standardized transition constants for consistent animations
 * across the application
 */

export const TRANSITIONS = {
  // Standard transition for theme changes and layout shifts
  STANDARD: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Fast transition for hover effects
  FAST: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Smooth transition for background colors
  BACKGROUND: 'background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Smooth transition for text colors
  COLOR: 'color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Combined transition for elements that change both bg and text
  THEME: 'background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Easing function
  EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
  
  // Duration
  DURATION: '300ms',
} as const
